export function isRunningAsPWA() {
  if (import.meta.server) return false;

  if (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    window.matchMedia('(display-mode: minimal-ui)').matches
  ) {
    return true;
  }

  // Old Safari iOS
  return 'standalone' in window.navigator && window.navigator.standalone === true;
}
